import { useQuery } from "@tanstack/react-query";
import { ZodSchema, type ZodObject } from "zod";

import type { PartConfig } from "@hsl/core/fund-page/schemas";

function usePartJSON<T>(
    enabled = true,
    params: Partial<PartConfig> & {
        shareClassID?: string;
        pricePartStartDate?: string;
        pricePartEndDate?: string;
        pricePartDay?: string;
        pricePartMonth?: string;
        pricePartYear?: string;
    },
    schema?: ZodSchema<T>,
) {
    const query = useQuery({
        queryKey: ["partJSON", params],
        enabled: enabled,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const {
                audienceId: audience,
                fundId: fund_id,
                shareClassID: shareclass_id,
                routeId: route,
                partId: id,
                version,
                languageId,
                baseUrl,
                pricePartEndDate,
                pricePartStartDate,
                pricePartDay,
                pricePartMonth,
                pricePartYear,
            } = params;
            const paramsList = [
                ["audience", audience],
                ["fund_id", fund_id],
                ["shareclass_id", shareclass_id],
                ["route", route],
                ["id", id],
                ["version", version],
                ["languageId", languageId],
                ["price_part_start_date", pricePartStartDate],
                ["price_part_end_date", pricePartEndDate],
                ["price_part_day", pricePartDay],
                ["price_part_month", pricePartMonth],
                ["price_part_year", pricePartYear],
            ].filter((x) => x[1] !== undefined && x[1] !== "undefined");
            const sp = new URLSearchParams(Object.fromEntries(paramsList));
            const res = await fetch(`${baseUrl ?? ""}/srp/api/part?${sp}`);
            const json = await res.json();

            if (!res.ok) {
                throw new Error(
                    `Failed to fetch part ${id} - ${res.status} ${res.statusText}`,
                );
            }
            const parsedData: T = schema?.parse(json) ?? json;
            return parsedData;
        },
    });

    return query;
}

export default usePartJSON;
